import React from 'react';
import { FormHelperText } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';

import { getStayDurationSummary } from '../../helpers/travelDateValidation';

type Props = {
	startDateName: string;
	endDateName: string;
	variant?: 'accommodation' | 'transfer';
};

const severityColor: Record<'info' | 'warning' | 'error', string> = {
	info: 'text.secondary',
	warning: 'error.main',
	error: 'error.main',
};

export const StayDurationHint = ({
	startDateName,
	endDateName,
	variant = 'accommodation',
}: Props): JSX.Element | null => {
	const { control } = useFormContext();
	const startDate = useWatch({ control, name: startDateName as any });
	const endDate = useWatch({ control, name: endDateName as any });

	const summary = getStayDurationSummary(startDate, endDate, { variant });

	if (!summary) {
		return null;
	}

	return (
		<FormHelperText
			component="div"
			sx={{
				color: severityColor[summary.severity],
				mt: 0.5,
				mx: 0,
				fontSize: '0.8rem',
				lineHeight: 1.4,
			}}
		>
			{summary.text}
		</FormHelperText>
	);
};
